import { createElement } from 'wsm-tagging-utils';

/**
 * Searches form for specified field and creates hidden field if not found.
 *
 * @param {jQuery} formElement The form being searched.
 * @param {string} hiddenFieldName The name of the field being searched for or created.
 * @param {string} [defaultValue] The value of the field if not defined.
 * @param {object} additionalAttributes An object of additional attributes you want to include on the input.
 * @returns {Object} The field input element that was found or created.
 */
const createOrUpdateHiddenField = (
	form,
	hiddenFieldName,
	defaultValue = '',
	additionalAttributes = {}
) => {
	let field;

	if (form) {
		field = form.querySelector(`input[name='${hiddenFieldName}']`);

		if (!field) {
			const attrs = Object.entries(additionalAttributes)
				.map(([key, value]) => `${key}="${value}"`)
				.join(' ');
			field = createElement(`
				<input type="hidden" name="${hiddenFieldName}" ${attrs}/>
			`);

			form.appendChild(field);
		}

		field.value = defaultValue;
	}

	return field;
};

export default createOrUpdateHiddenField;
